import { Ordering } from '../common-enums';
export const defaultPaginationConfig = {
    replyShowMoreLimit: 10,
    ordering: Ordering.NEWEST_FIRST,
    initialPage: {
        commentLimit: 5,
        replyLimit: 1,
    },
    pagination: {
        commentLimit: 15,
        replyLimit: 3,
    },
    maxPagesBeforeDrop: {
        commentPages: 4,
        replyPages: 5,
    },
};
export const defaultReactionsConfig = {
    commentReactions: { type: 'likes', mainEmotion: 'heart' },
    replyReactions: { type: 'likes', mainEmotion: 'heart' },
};
//# sourceMappingURL=config-defaults.js.map